<div class="complete-profile-confirmation-container" id="complete-profile-confirmation-container">
  <div id="confirmation-container">
    <div class="row no-gutters">
      <div class="col-md-12" id="profile-confirmation-container">
        <div id="confirmation-header">
          <div id="complete-profile-confirmation-check" class="check">
            <div class="image" id="img">
              <img id="check-icon" src="assets/images/utf_success.svg" alt="Check">
            </div>
            <div>
              <h1 style="display:none;">Fix for sonar issues</h1>
              <div id="profile-all-heading">
                <p class="profile-heading">
                  {{cfetLabels.utf_complete_profile_confirmation.profile_confirmation_heading}}, {{firstName}}!</p>
                <p class="profile-heading" *ngIf="linkCuser !== ''" [innerHTML]="skipDocUpload ?
    (cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc_utf_territorya + '<br>&nbsp;<br>' +
    cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc_utf_territoryb) :
    cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc_utf">
                </p>
                  <p class="profile-heading" *ngIf="linkCuser === ''">
                    {{cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc}}</p>
              </div>
            </div>
          </div>
          <p class="skipDocupload" *ngIf="linkCuser !== '' && skipDocUpload">
            {{cfetLabels.utf_complete_profile_confirmation.utf_territory_desc1a}}
          </p>
          <div *ngIf="skipDocUpload" class ="calendar-button">
            <span class ="calendar-button">
              <add-to-calendar-button class ="calendar-button"
                size = "3"
                attr.label = {{calendarButtonText}}
                attr.name = {{calendarName}}
                attr.options = {{calendarOptions}}
                attr.location = {{calendarLocation}}
                attr.startDate = {{calendarStartDate}}
                attr.endDate = {{calendarEndDate}}
                attr.startTime = {{calendarStartTime}}
                attr.endTime = {{calendarEndTime}}
                attr.timeZone = {{calendarTimeZone}}
                attr.description = {{calendardescription}}>
              </add-to-calendar-button>
            </span>
          </div>
          <div id="complete-profile-confirmation-desc">
            <p id="profile-desc">
              {{emailAddress}}
            </p>
            <div id="profile-desc1" *ngIf="linkCuser !== ''">
              <p *ngIf="skipDocUpload === undefined || hasDomainValue === true">
                {{ cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc1_utf }}
              </p>
              <p id="profile-desc2" *ngIf="skipDocUpload === true || skipDocUpload === false">
                {{ cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc1a_territory }}
              </p>
              <p id="profile-desc4" *ngIf="skipDocUpload === true || skipDocUpload === false">
                {{ cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc2a_territory }}
              </p>
            </div>
            <p id="profile-desc1" *ngIf="linkCuser === ''">
              {{cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc1_territory}}</p>
            <p id="profile-desc4" *ngIf="linkCuser !== '' && hasDomainValue === true">
              {{cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc2_utf}}</p>
            <p id="profile-desc4" *ngIf="linkCuser !== '' && (skipDocUpload === undefined || hasDomainValue === true)">
              {{cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc3_utf}}</p>
            <p id="profile-desc2" *ngIf="linkCuser === ''">
              {{cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc2_territory}}</p>

            <p id="profile-desc3" *ngIf="linkCuser === ''">
              {{cfetLabels.utf_complete_profile_confirmation.profile_confirmation_desc3_territory}}</p>
          </div>

          <div class="action-divider-row">
            <hr class="action-divider1">
          </div>
          <div class="row no-gutters">
            <div class="col-md-3"></div>
            <ng-container *ngIf="attId === '' || isReturnUrl">
              <div class="col-md-6" id="profile-footer-column"
                *ngIf="skipDocUpload === undefined || skipDocUpload === false">
                <button type="button" id="btn-continue" (click)="continue($event)" (keyup)="continue($event)"
                  tabindex="0">
                  {{cfetButtonLabels.button_labels.continue}}
                </button>
              </div>
              <div class="col-md-6" id="profile-footer-column" *ngIf="skipDocUpload === true">
                <button type="button" id="btn-shopNowFirstnet" (click)="shopNowFirstnet($event)"
                  (keyup)="shopNowFirstnet($event)" tabindex="0">
                  <em aria-label=""></em>
                  {{ cfetButtonLabels.button_labels.continue }}
                </button>
              </div>
            </ng-container>
            <div id="profile-footer-column2" class="profile-footer-column2" *ngIf="attId !== '' && !isReturnUrl">
              <div class="col-md-12" class="btn-container">
                <button type="button" id="btn-shopNow" (click)="shopNow($event)" (keyup)="shopNow($event)" tabindex="0">
                  <em aria-label=""></em>
                  {{cfetButtonLabels.button_labels.shopNow}}</button>
                <button type="button" id="btn-changePlan" (click)="changePlan($event)" (keyup)="changePlan($event)"
                  tabindex="0">
                  <em aria-label=""></em>
                  {{cfetButtonLabels.button_labels.changePlan}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
</div>
